import React from 'react';

import AlertBanner from '~/components/core/AlertBanner';
import { prettifyKey } from '~/Utils';

import type { PromotionBlockedSection } from './types';

const BLOCKED_SIDE_LABEL: Record<PromotionBlockedSection['side'], string> = {
  source: 'this organization',
  target: 'the target organization',
};

/** A configuration section left out of a promotion (or a rollback's restore) because its export is blocked:
 * shown disabled, with no checkbox and outside every count, and one row per offender beneath it. */
const BlockedSectionGroup: React.FC<{ section: PromotionBlockedSection }> = ({ section }) => (
  <div className="rounded-md border border-solid border-slate-300">
    <div className="flex items-center justify-between bg-slate-100 px-12 py-8">
      <span className="font-bold text-slate-700">{prettifyKey(section.configuration_type)}</span>
      <span className="text-slate-800">Not included</span>
    </div>
    <div className="px-12 py-8">
      <AlertBanner
        withIcon
        alertType={AlertBanner.ALERT_TYPES.WARNING}
        note={
          <div className="flex flex-col gap-8">
            <span>
              Can’t be included: {BLOCKED_SIDE_LABEL[section.side]} has content that depends on items outside it. Fix
              the items below to include it.
            </span>
            {section.reasons.length > 0 && (
              <ul className="list-disc pl-16">
                {/* Two offenders can share a sentence, and the list is fixed per response, so the index keeps the
                    keys unique (as in PromotionExportBlockedBanner). */}
                {section.reasons.map((reason, index) => (
                  <li key={`${index}-${reason}`}>{reason}</li>
                ))}
              </ul>
            )}
          </div>
        }
      />
    </div>
  </div>
);

export default BlockedSectionGroup;
